<template>
  <form class="p-1">
    <div class="flex w-full space-x-6">
      <BaseInput
        v-model="formData.firstName"
        :name="'firstName'"
        :label="'First name'"
        :validate="validate"
        :schema="firstNameSchema"
        :focus="false"
      />
      <BaseInput
        v-model="formData.lastName"
        :name="'lastName'"
        :label="'Last name'"
        :validate="validate"
        :schema="lastNameSchema"
      >
        <template v-slot:hint> optional</template>
      </BaseInput>
      <BaseInput
        v-model="formData.weeklyWorkingHours"
        :name="'weeklyWorkingHours'"
        :label="'Weekly working hours'"
        :validate="validate"
        :schema="weeklyWorkingHoursSchema"
        :inputSize="'sm'"
        :addon="'right'"
        inputmode="numeric"
        maxLength="2"
      >
        <template v-slot:addon-right>hours</template>
      </BaseInput>
    </div>
    <div class="flex pt-2 space-x-2">
      <BaseButton @btn-click="onClose" :variant="'default'">Cancel</BaseButton>
      <BaseButton form="employee-form" :variant="'primary'" :loading="loading" @btn-click="onSubmit">Create</BaseButton>
    </div>
    <div v-if="error" class="text-red-600">{{ error }}</div>
  </form>
</template>

<script lang="ts">
// components
import { defineComponent } from "vue";
// store
import useEmployeeStore, { createAbbreviation } from "@/store/useEmployeeStore";
// other
import useEmployeeForm from "./useEmployeeForm";
import { getRandomColor } from "@/utils/colorHelpers";

export default defineComponent({
  name: "EmployeeForm",
  components: {},
  setup(props, context) {
    // store
    const { onCreateEmployee, onCreateEmployeeSuccess, loading, error } = useEmployeeStore();

    // employee form hook
    const {
      formData,
      resetForm,
      employeeCreateSchema,
      validate,
      firstNameSchema,
      lastNameSchema,
      weeklyWorkingHoursSchema
    } = useEmployeeForm({ firstName: "", lastName: "", abbreviation: "", color: "", weeklyWorkingHours: "" });

    // Validate and create employee
    const onSubmit = () => {
      // create abbreviaiton and color
      formData.abbreviation = createAbbreviation(formData.firstName, formData.lastName);
      formData.color = getRandomColor();
      employeeCreateSchema
        .validate(formData)
        .then(() => {
          // execute api call
          onCreateEmployee(
            formData.firstName,
            formData.lastName,
            formData.abbreviation,
            formData.color,
            formData.weeklyWorkingHours
          );
        })
        .catch(() => (validate.value = true));
    };

    // close form and reset data
    const onClose = () => {
      validate.value = false;
      resetForm();
      context.emit("close");
    };

    // cleanup after successful action
    onCreateEmployeeSuccess(() => {
      console.info("Employee successfully created");
      onClose();
    });

    return {
      formData,
      validate,
      firstNameSchema,
      lastNameSchema,
      weeklyWorkingHoursSchema,
      onSubmit,
      onClose,
      loading,
      error
    };
  }
});
</script>

<style></style>
